import { useTranslation } from 'react-i18next'
import './transaction-details.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  icon?: string
  img?: string
  title: string
  value: any
  isMoney?: boolean
  hideValue?: boolean
  subTitle?: string
  aliquot?: number
  inOrOut?: 'in' | 'out'
  titleStyle?: React.CSSProperties
}

export default ({ icon, title, subTitle, value, isMoney = true, hideValue = false, aliquot, inOrOut, titleStyle, img }: Props) => {
  const { t } = useTranslation('transactionDetails')

  return (
    <section className="transaction-details">
      <div className="transaction-info">
        {icon ? (
          <span className={'transaction-icon icon'}>
            <i className={icon}></i>
          </span>
        ) : img ? (
          <span className={'transaction-icon img'}>
            <img src={img} alt={title} title={title} className="transaction-icon" />
          </span>
        ) : null}
        <div>
          <h5 style={{ ...titleStyle }}>
            {title} {aliquot ? <span>({aliquot.toLocaleString('en', { style: 'percent', minimumFractionDigits: 1 })})</span> : null}
          </h5>
          {subTitle ? <p>{t(subTitle)}</p> : null}
        </div>
      </div>
      <span className={`transaction-value ${inOrOut || ''}`} style={hideValue ? { fontSize: '2rem' } : undefined}>
        {inOrOut === 'out' ? '- ' : ''}
        {hideValue
          ? '••••••'
          : isMoney
          ? value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })
          : value}
      </span>
    </section>
  )
}
